import { diffWordsWithSpace } from 'diff';

export type WordDiffSegment = {
  type: 'added' | 'removed' | 'unchanged';
  value: string;
};

// Whitespace is significant, so the segments reconstruct both inputs exactly: everything that
// isn't `added` joins back to `current`, everything that isn't `removed` joins back to `suggested`.
// `current`/`suggested` are typed `string` upstream, but the BE sends `null` for an
// absent prompt/value, so coerce before diffing (`diffWordsWithSpace` throws on null).
export const computeWordDiff = (
  current: string | null | undefined,
  suggested: string | null | undefined,
): WordDiffSegment[] => {
  return diffWordsWithSpace(current ?? '', suggested ?? '').map(part => {
    if (part.added) {
      return { type: 'added', value: part.value };
    }
    if (part.removed) {
      return { type: 'removed', value: part.value };
    }
    return { type: 'unchanged', value: part.value };
  });
};
